module.exports = __webpack_public_path__ + "media/images/common/pager-arrow-next-67c87287594a8aaa290187bc120d30ba.svg";